import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import { openWishListModal } from '../../actions/WishList/modalActions';
import { openLoginModal } from '../../actions/modalActions';
import { getwishListStatus } from '../../helpers/wishListStatus';
import messages from '../../locale/messages';
import { withQuery } from '../../hoc/withGraphql';

import heartImage from '/public/SiteIcons/heartrIconOff.svg';
import heartIconFill from '/public/SiteIcons/heartIconOn.svg'
import heartImageView from '/public/SiteIcons/heart.png';
import heartIconFillView from '/public/SiteIcons/heartFill.svg'


//Styles
import s from './WishListIcon.css';
import cs from '../commonStyle.css';

const WishListIcon = ({
    isChecked = false,
    type = 'icon',
    listId,
    isAuthenticated,
    wishListModalStatus,
    wishListRoomId,
    openLoginModal,
    openWishListModal,
    isViewListing,
    heartIcon,
    key
}) => {
    const [iconSelected, setIconSelected] = useState(isChecked);
    const [clicked, setClicked] = useState(false);

    // Effect to handle initial icon state
    useEffect(() => {
        if (!clicked && !wishListModalStatus) {
            setIconSelected(isChecked);
        }
    }, [isChecked, clicked, wishListModalStatus]);

    // Effect to handle wishlist modal status changes
    useEffect(() => {
        const updateWishListStatus = async () => {
            if (wishListRoomId && wishListModalStatus === false) {
                const currentWishListStatus = await getwishListStatus(listId);
                setIconSelected(currentWishListStatus);
            }
        };

        updateWishListStatus();
    }, [wishListModalStatus, wishListRoomId, listId]);

    const handleIconAction = () => {
        if (isAuthenticated) {
            setClicked(true);
            openWishListModal(listId, isViewListing);
        } else {
            openLoginModal();
        }
    };

    const renderIcon = () => (
        <div className={cx(s.iconContainer, heartIcon, 'heartIconRtl')} onClick={handleIconAction}>
            <img
                src={iconSelected ? heartIconFill : heartImage}
                className={cx(s.wishListIcon)}
                alt={'Wishlist'}
            />
        </div>
    );

    const renderButton = () => (
        <div
            className={cx(s.buttonContainer, s.iconAlignCenter)}
            onClick={handleIconAction}
        >
            <img
                src={iconSelected ? heartIconFillView : heartImageView}
                className={cx(s.wishListIcon, s.vtrMiddle, s.heardIconSize)}
                alt={'Wishlist'}
            />
            <span className={cx(s.buttonText, s.vtrBottom, cs.flexShrinkNone)}>
                {iconSelected 
                    ? <FormattedMessage {...messages.saved} /> 
                    : <FormattedMessage {...messages.wishListSave} />
                }
            </span>
        </div>
    );

    return (
        <div key={key}>
            {type === 'icon' ? renderIcon() : renderButton()}
        </div>
    );
};

WishListIcon.propTypes = {
    isChecked: PropTypes.bool,
    type: PropTypes.string,
    listId: PropTypes.number.isRequired,
    isAuthenticated: PropTypes.bool,
    wishListModalStatus: PropTypes.bool,
    wishListRoomId: PropTypes.number,
    openLoginModal: PropTypes.func.isRequired,
    openWishListModal: PropTypes.func.isRequired,
    isViewListing: PropTypes.bool,
    heartIcon: PropTypes.string,
    key: PropTypes.string
};

const mapState = (state) => ({
    isAuthenticated: state.runtime.isAuthenticated,
    wishListModalStatus: state.modalStatus.wishListModalOpen,
    wishListRoomId: state.modalStatus.listId
});

const mapDispatch = {
    openLoginModal,
    openWishListModal
};

// GraphQL query
const WISHLIST_QUERY = gql`
    query UserListing($listId: Int!, $preview: Boolean) {
        UserListing (listId: $listId, preview: $preview) {
            wishListStatus
        }
    }     
`;

export default compose(
    injectIntl,
    withStyles(s, cs),
    connect(mapState, mapDispatch),
    withQuery(WISHLIST_QUERY, {
        options: (props) => ({
            variables: {
                listId: props?.listId
            },
            ssr: false
        })
    })
)(WishListIcon);

